if (!customElements.get('vayndo-product-rail')) {
  customElements.define('vayndo-product-rail', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const rail = this.querySelector('.vnd-store-rail');
      const buttons = [...this.querySelectorAll('button[data-direction]')];
      if (!rail) return;
      const update = () => {
        const max = rail.scrollWidth - rail.clientWidth;
        for (const button of buttons) button.disabled = Number(button.dataset.direction) < 0 ? rail.scrollLeft <= 2 : rail.scrollLeft >= max - 2;
      };
      for (const button of buttons) button.addEventListener('click', () => {
        rail.scrollBy({left: Number(button.dataset.direction) * rail.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }, {signal: this.abort.signal});
      rail.addEventListener('scroll', update, {signal: this.abort.signal, passive: true});
      this.observer = new ResizeObserver(update); this.observer.observe(rail); update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}
